export const cards = [
  {
    id: 1,
    type: "blog",
    title: "OUR PRODUCTS",
    imgSrc: "/images/why_choose_classy_closets/our-products.png",
    contentTitle: "",
    content: "",
    btnText: "View All",
    href: "/view-all-products"
  },
  // {
  //   id: 2,
  //   type: "blog",
  //   title: "ON THE BLOG",
  //   imgSrc: "/images/home_page/custom_homeoffice.jpg",
  //   contentTitle: "",
  //   content: "",
  //   btnText: "View Blog",
  //   href: "/blog"
  // },
  {
    id: 3,
    type: "blog",
    title: "OUR STORY",
    imgSrc: "/images/why_choose_classy_closets/our_story.png",
    contentTitle: "",
    content: "",
    btnText: "About Us",
  },
];
